import {
  faBugSlash,
  faCalendarClock,
  faCat,
  faCheck,
  faShieldDog,
  faTimer,
  faUtensils,
  faWater,
  IconDefinition,
  fa8,
  faAlarmSnooze,
  faAward,
  faBoxCheck,
  faCircleDollar,
  faDumbbell,
  faHandFist,
  faHeart,
  faPaw,
  faShieldVirus,
  faSquare8,
  faStethoscope,
  faTablets,
  faThumbsUp,
  faArrowUpRightAndArrowDownLeftFromCenter,
  faCalendarCheck,
  faCalendarDays,
  faCalendars,
  faDog,
  faHandsBubbles,
  faPrescriptionBottle,
  faShieldCat,
  faShieldCheck,
  faStar,
  faWeightScale,
  faWorm,
  faBanBug,
  faBugs,
  faMicroscope,
  faCalendar,
  faDroplet,
} from "@fortawesome/pro-light-svg-icons";

const SUPPORTED_FACT_ICONS: IconDefinition[] = [
  faCheck,
  faCalendarClock,
  faBugSlash,
  faUtensils,
  faWater,
  faCat,
  faShieldDog,
  faTimer,
  faMicroscope,
  faDroplet,
  faPaw,
  faArrowUpRightAndArrowDownLeftFromCenter,
  faHandFist,
  faCalendarCheck,
  faBoxCheck,
  faCalendarDays,
  faCircleDollar,
  faTablets,
  faStethoscope,
  faBugs,
  faHandsBubbles,
  faBanBug,
  fa8,
  faDog,
  faThumbsUp,
  faWorm,
  faAlarmSnooze,
  faDumbbell,
  faShieldCheck,
  faWeightScale,
  faAward,
  faShieldCat,
  faSquare8,
  faShieldVirus,
  faCalendar,
  faCalendars,
  faHeart,
  faPrescriptionBottle,
  faStar,
];

const FACT_ICON_LOOKUP: Record<string, IconDefinition> = SUPPORTED_FACT_ICONS.reduce(
  (acc, icon) => ({ ...acc, [icon.iconName]: icon }),
  {},
);

/**
 * Gets the fact icon defined in the FactModel
 *
 * @param iconName Icon lookup name
 * @returns Font awesome icon
 */
export const getFactIcon = (iconName: string) => FACT_ICON_LOOKUP[iconName] || faCheck;
